document.addEventListener('DOMContentLoaded', () => {
    const dotElements = document.querySelectorAll('.team-presentation__dot-item')
    const teamContainer = document.getElementById('team-container')
    const clickNext = document.querySelectorAll('.team-presentation__click-next')
    const clickPrevious = document.querySelectorAll('.team-presentation__click-previous')

  clickNext.forEach((click) => {
    click.addEventListener('click', () => {
      teamContainer.scrollBy({
        left: teamContainer.offsetWidth,
        behavior: 'smooth'
      })
    })
  })

  clickPrevious.forEach((click) => {
    click.addEventListener('click', () => {
      teamContainer.scrollBy({
        left: -teamContainer.offsetWidth,
        behavior: 'smooth'
      })
    })
  })
  function setActiveScrollDot() {
    dotElements.forEach((dotElement) => {
      dotElement.classList.remove('active')
    })
    const activeDot = Math.ceil(teamContainer.scrollLeft / teamContainer.offsetWidth)
    const activeDotElements = document.getElementsByClassName(`team-presentation__dot-item ${activeDot}`)
    Array.from(activeDotElements).forEach((activeDotElement) => {
      activeDotElement.classList.add('active')
    })
  }

  teamContainer.addEventListener('scroll', () => {
    setActiveScrollDot()
  })

  setActiveScrollDot()

  window.addEventListener('resize', () => {
    teamContainer.scrollTo({ left: 0, behavior: 'smooth'})
  })
})
